import { Form } from 'antd';
import { RefObject } from 'react';
import { FormInstance } from 'antd/es/form/hooks/useForm';
import { InfiniteSearchSelect } from '../common/components';
import { useInfiniteSearchGroupDescriptionQuery } from './query/useInfiniteSearchGroupDescriptionQuery';

interface DataObjectFilterInputProps {
  formRef: RefObject<FormInstance | null>;
  onChange?: (value?: string) => void;
  value?: string;
  selectedDescription?: string;
}

export const GroupDescriptionFilterInput = (
  props: DataObjectFilterInputProps,
) => {
  const { value, onChange, selectedDescription } = props;

  const descriptionType = Form.useWatch(
    'descriptionType',
    props.formRef.current ?? undefined,
  );

  return (
    <InfiniteSearchSelect
      id="group-description-filter"
      value={value}
      onChange={onChange}
      searchOptions={{
        selectedCode: selectedDescription,
        type: descriptionType,
      }}
      useSearchHook={useInfiniteSearchGroupDescriptionQuery}
    />
  );
};
